import React from 'react';

import { EnvironmentProvider } from '../../contexts/EnvironmentContext';

import CreateAccountComponent from './components/CreateAccountComponent';

type TCreateAccountAppProps = {
  environment: any;
};

const CreateAccountApp = ({ environment }: TCreateAccountAppProps) => (
  <EnvironmentProvider value={environment}>
    <CreateAccountComponent />
  </EnvironmentProvider>
);

export default CreateAccountApp;
